import axios from "axios";
import { getOrganizationSettings } from "../utils/storage";

// const APPID = process.env.REACT_APP_APPID;
const API_URL = process.env.REACT_APP_API_URL

const axiosPublic = axios.create({
  baseURL: API_URL,
});

// Add interceptors
axiosPublic.interceptors.request.use(
  async (config) => {
      const newOrg = getOrganizationSettings();
      const appid = newOrg.id;
      
    
      config.headers["Accept"] = 'application/json';
      config.headers["Content-Type"] = 'application/json';
      config.headers["AppID"] = appid;
    
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosPublic;
